var globalHelpers = require('../../globalHelpres');
module.exports = function(app) {
	'use strict'
	app.directive('aiEditorDir',aiEditorDir);
	aiEditorDir.$inject=['$timeout'];
	function aiEditorDir($timeout) {
		return {
			restrict: 'E',
			scope:{
				funcionality: '=',
                resultFromAi: '=',
                selectedSuggestion: '=',
                text: '=',
                twoColumns: '=',
                diffText: '='
			},      
			replace:true,
			template: require('./partial/aiEditor.html'),
			link: function(scope, ele, $attrs, ctrl) {
                // Remove only summaryblock from original text and store it in a way that won't be affected by editor
                scope.originalText = {content: scope.text.replace(/<summaryblock>[\s\S]*?<\/summaryblock>/g, '')};
                // Store original content in a closure to prevent it from being modified
                scope.aiSuggestion = {content: ''};
                var originalText = scope.originalText.content;
                var resultFromAi = scope.resultFromAi;
                // Watch for changes in the aiSuggestion using a function
                scope.$watch(function() {
                    return scope.aiSuggestion.content;
                }, function(newVal, oldVal) {
                    // Skip if the value hasn't actually changed
                    if (newVal === oldVal) {
                        return;
                    }
                    if(scope.funcionality === 'text-summary') {
                        // Remove any trailing paragraph tags
                        newVal = newVal.replace(/<p>\s*<\/p>$/, '');
                        // Replace consecutive paragraph tags with |*|
                        var formattedText = newVal.replace(/<\/p>\s*<p>/g, '|*|');
                        // Remove any remaining paragraph tags
                        formattedText = formattedText.replace(/<\/?p>/g, '');
                        // Wrap in summary shortcode
                        scope.selectedSuggestion.value = (formattedText.length > 0) ? '[summary]' + formattedText + '[/summary]' : '';
                    } else {
                        if (scope.diffText) {
                            // Remove diff spans and keep their content
                            newVal = newVal.replace(/<span class="diff"[^>]*>(.*?)<\/span>/g, '$1');
                        }
                        // Clean up any empty paragraphs before setting the value
                        newVal = newVal.replace(/<p>\s*<\/p>/g, '');
                        scope.selectedSuggestion.value = newVal;
                    }
                });
                if(scope.funcionality === 'text-summary') {
                    if(scope.resultFromAi.length > 0) {
                        // timout is needed for watcher on initial load for mac chrome, it's not needed for other browsers
                        $timeout(function() {
                            // Convert array of facts to string with paragraph tags
                            scope.aiSuggestion.content = scope.resultFromAi.map(function(fact) {
                                // Remove any existing line breaks and trim
                                return '<p>' + fact.replace(/[\r\n]+/g, '').trim() + '</p>';
                            }).join('');
                        }, 0);
                    }
                } else {
                    // Apply diff highlighting only on initial load if diffText is true
                    if (scope.diffText) {
                        $timeout(function() {
                            scope.aiSuggestion.content = globalHelpers.highlightDifferences(originalText, resultFromAi);
                        }, 0);
                    } else {
                        $timeout(function() {
                            scope.aiSuggestion.content = scope.resultFromAi;
                        }, 0);
                    }
                }

			}       
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/AIModal/aiEditorDirective.js
// module id = 427
// module chunks = 0